import { Button, Grid, Typography } from '@material-ui/core';

import CreditCardIcon from '@material-ui/icons/CreditCard';
import React from 'react';

const PaymentMethod = (props) => {
  const { profile, HandleRemove } = props;
  const card = profile.payment.creditCard;
  return (
    <Grid container spacing={3} className='card-row'>
      <Grid xs={12} sm={8} item className='details'>
        <Typography variant='body1'>
          <CreditCardIcon />
          {card.cardType}
          {' Card Ending in '}
          {card.cardNumber}
        </Typography>
        <Grid container className='card-info'>
          <Grid item xs={12} sm={3}>
            <Typography variant='h4'>{'Name on Card'}</Typography>
            <Typography variant='body1'>
              {profile?.billTo?.firstName}
              {' '}
              {profile?.billTo?.lastName}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={5}>
            <Typography variant='h4'>{'Billing Address'}</Typography>
            <Typography variant='body1'>
              {profile?.billTo?.firstName}
              {' '}
              {profile?.billTo?.lastName}
            </Typography>
            <Typography variant='body1'>{profile?.billTo?.address}</Typography>
            <Typography variant='body1'>
              {profile?.billTo?.city}
              {', '}
              {profile?.billTo?.state}
              {' '}
              {profile?.billTo?.zip}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid xs={12} sm={4} item className='button-wrapper'>
        <Button className='remove-card-button' variant='contained' color='primary' onClick={() => HandleRemove(profile.customerPaymentProfileId)}>
          {'Remove Card'}
        </Button>
      </Grid>
    </Grid>
  );
};

export default PaymentMethod;
